//Set your global param here! e.g setting

var projectName = "ProtivitiBusinessResilienceGenerator" //Project name
var loadingImage = "/assets/image/loading.gif" //Image for loading